<template>
  <div class="nowrap tenant-status-container">
    <div v-if="tenant.status === tenantStatuses.DRAFT.value">
      <v-icon color="yellow darken-2">lens</v-icon> Draft
    </div>
    <div v-else-if="tenant.status === tenantStatuses.ACTIVE.value">
      <v-icon color="green">lens</v-icon> Active
    </div>
    <div v-else-if="tenant.status === tenantStatuses.SUSPENDED.value">
      <v-icon color="red darken-1">lens</v-icon> Suspended
    </div>
    <div v-else>
      <v-icon color="black">lens</v-icon> {{ tenant.status }}
    </div>
  </div>
</template>

<script>
import { tenantStatuses } from '../../utils/PfxUtils.js'
export default {
  name: 'TenantStatusIndicator',
  props: {
    tenant: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      tenantStatuses
    }
  }
}
</script>

<style  lang="scss" scoped>

  .tenant-status-container {
    i { font-size: .8rem; } // custom size for v-icon
  }

</style>



// WEBPACK FOOTER //
// src/components/elements/TenantStatusIndicator.vue